import * as z from "zod/v4";

const errorMessageEntrySchema = z.object({
  type: z.enum(["terminal", "retryable"]),
  rawErrorMessage: z.string(),
  prettyErrorMessage: z.string(),
});

export const getErrorMessages = {
  name: "getErrorMessages" as const,
  input: z.object({}),
  output: z.object({ errorMessages: z.array(errorMessageEntrySchema) }),
};
